import React, { useState } from 'react';
import { Autocomplete, InputAdornment, IconButton } from '@mui/material';
import GridPicker from './GridPicker';

// Shared ranking: exact, starts with, word starts with, contains (alphabetical within each)
const blScore = (label, q) => { const v = String(label || '').toLowerCase(); if (!q) return 0; if (v === q) return 0; if (v.startsWith(q)) return 1; if (v.split(/[^a-z0-9#]+/).some((w) => w.startsWith(q))) return 2; return v.includes(q) ? 3 : 4; };
const blRank = (opts, q, labelOf, keepAll) => { const s = String(q || '').toLowerCase().trim(); if (!s) return opts; return opts.map((o) => [o, blScore(labelOf(o), s)]).filter((x) => keepAll || x[1] < 4).sort((x, y) => x[1] - y[1] || String(labelOf(x[0])).localeCompare(String(labelOf(y[0])))).map((x) => x[0]); };

// Drop-in for MUI <Autocomplete>: typing works as before; lists with 7+ options also get a grid browse button.
export default function GridAutocomplete(props) {
    const { gridColumns, gridRow, options, onChange, renderInput, getOptionLabel, minForGrid = 1, ...rest } = props;
    const [open, setOpen] = useState(false);
    const [blTyped, setBlTyped] = useState('');
    const list = options || [];
    const labelOf = (o) => (getOptionLabel ? getOptionLabel(o) : typeof o === 'string' ? o : (o && (o.label || o.name)) || '');
    const useGrid = list.length >= minForGrid;
    const blCounts = {}; list.forEach((o) => { const l = labelOf(o); blCounts[l] = (blCounts[l] || 0) + 1; });
    const labelFull = (o) => { const l = labelOf(o); const sp = o && typeof o === 'object' && (o.specimenType || o.specimen_type); return blCounts[l] > 1 && sp ? l + ' \u00b7 ' + sp : l; };
    const blKey = (o, st) => (o && typeof o === 'object' && (o._id || o.id || o.value)) || (labelOf(o) + '#' + ((st && st.index) || 0));
    const wrapInput = (params) => {
        const el = renderInput(params);
        if (!useGrid || !React.isValidElement(el)) return el;
        const ip = el.props.InputProps || params.InputProps || {};
        return React.cloneElement(el, {
            InputProps: {
                ...ip,
                endAdornment: (
                    <>
                        <InputAdornment position="end">
                            <IconButton size="small" title="Browse list" onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
                                <i className="fas fa-th-list" style={{ fontSize: 15 }}></i>
                            </IconButton>
                        </InputAdornment>
                        {ip.endAdornment}
                    </>
                )
            }
        });
    };
    return (
        <>
            <Autocomplete {...rest} renderOption={rest.renderOption ? (p, o, st) => { const el = rest.renderOption(p, o, st); return React.isValidElement(el) ? React.cloneElement(el, { key: blKey(o, st) }) : el; } : (p, o, st) => <li {...p} key={blKey(o, st)}>{labelFull(o)}</li>} onInputChange={(e, v, r) => { setBlTyped(r === 'input' ? v : ''); if (rest.onInputChange) rest.onInputChange(e, v, r); }} filterOptions={(opts, st) => { const q = (st && st.inputValue) || blTyped; return rest.filterOptions ? blRank(rest.filterOptions(opts, { ...st, inputValue: q }), q, labelFull, true) : blRank(opts, q, labelFull, false); }} options={list} getOptionLabel={(o) => labelFull(o)} onChange={onChange} renderInput={wrapInput} />
            {open && useGrid && (
                <GridPicker
                    rows={list.map((o, i) => ({ value: i, label: labelOf(o), ...(gridRow ? gridRow(o) : {}) }))}
                    columns={gridColumns || [{ key: 'label', label: 'Name', bold: true }]}
                    placeholder="Search…"
                    onClose={() => setOpen(false)}
                    onSelect={(r) => { const opt = list[r.value]; if (rest.multiple) { const cur = Array.isArray(rest.value) ? rest.value : []; if (!cur.some((v) => v === opt || labelOf(v) === labelOf(opt)) && onChange) onChange({}, [...cur, opt], 'selectOption'); } else { setOpen(false); if (onChange) onChange({}, opt, 'selectOption'); } }}
                />
            )}
        </>
    );
}
